
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AuthService} from '../../../services/api/auth/auth.service';
import {SessionService} from '../../../services/local/session/session.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private sessionService: SessionService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.whoAmI().pipe(map(result => {
      return true;
    }),
    catchError(err => {
      this.router.navigateByUrl('/auth/login');
      return observableThrowError(false);
    }));
  }
}
